import { render, staticRenderFns } from "./FinetuneSuggestionDetailThreshold.vue?vue&type=template&id=6205abda&scoped=true&"
import script from "./FinetuneSuggestionDetailThreshold.vue?vue&type=script&lang=js&"
export * from "./FinetuneSuggestionDetailThreshold.vue?vue&type=script&lang=js&"
import style0 from "./FinetuneSuggestionDetailThreshold.vue?vue&type=style&index=0&id=6205abda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6205abda",
  null
  
)

export default component.exports